import { TrialStatusEnum } from "../../../../domain/model/model-enums";
import { UserInfo } from "../../../../domain/model/user-info";
import { DataStoreId } from "../../data-store-id.type";
import { StoreTrialPhase } from "./store-trial-phase";
import { StoreTrialDates } from "./store-trial-dates";
import { Uuid } from "../../../../domain/model/uuid/uuid.type";

export class StoreTrial implements DataStoreId {
  readonly id: string;
  readonly name: string;
  readonly trialIdentifier: string;
  readonly description: string;
  readonly status: TrialStatusEnum;
  readonly createdBy: UserInfo;
  readonly trialDates: StoreTrialDates;
  readonly phases: StoreTrialPhase[];
  readonly sectionsIds: string[];
  readonly penIds: string[];
  readonly batchIds: string[];

  constructor(
    id: Uuid,
    name: string,
    trialIdentifier: string,
    description: string,
    status: TrialStatusEnum,
    createdBy: UserInfo,
    trialDates: StoreTrialDates,
    phases: StoreTrialPhase[],
    sectionsIds: string[],
    penIds: string[],
    batchIds: string[]
  ) {
    this.id = id.asString();
    this.name = name;
    this.trialIdentifier = trialIdentifier;
    this.description = description;
    this.status = status;
    this.createdBy = createdBy;
    this.trialDates = trialDates;
    this.phases = phases;
    this.sectionsIds = sectionsIds;
    this.penIds = penIds;
    this.batchIds = batchIds;
  }
}
